import { Box, Button, Grid } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";
import TextField from "@mui/material/TextField";
import { useMap } from "react-map-gl";
import { useRecoilState } from "recoil";
import { filterState } from "../context/states";
import { theme } from "../styles/theme";
import AutocompleteStyled from "./AutocompleteStyled";
import { LocationCategorySelector } from "./LocationCategorySelector";
import { RegionSelector } from "./RegionSelector";
import CloseIcon from "./icons/CloseIcon";
import ResetIcon from "./icons/ResetIcon";

export default function MapFilter({
  categories,
  regions,
  zipcodes,
  handleToggle,
}) {
  const [filter, setFilter] = useRecoilState(filterState);
  const { map } = useMap();

  const handleZipcodeSelectedAutocomplete = (event, newValue) => {
    if (newValue) {
      setFilter({ ...filter, zipcode: newValue });
      map.easeTo({
        center: [newValue.lng, newValue.lat],
        duration: 1500,
        zoom: 6.85,
      });
    } else {
      setFilter({ ...filter, zipcode: null });
    }
  };

  const handleResetFilter = () => {
    setFilter({});
  };

  const handleRegionSelected = async (event) => {
    if (event.target.value) {
      const result = await fetch(
        `https://api.showcase.nrw/zipcodes/findbyregion?region=${
          event.target.value?.id ?? event.target.value
        }`,
      );
      const zipcodes = await result.json();
      setFilter({
        ...filter,
        regionZipcodes: zipcodes,
        region: event.target.value,
      });
    } else {
      setFilter({ ...filter, regionZipcodes: null, region: null });
    }
  };

  return (
    <>
      <AutocompleteStyled
        label="Umkreissuche"
        placeholder="Deine PLZ"
        options={zipcodes}
        getOptionLabel={(zipcode) => `${zipcode.zipcode} ${zipcode.label}`}
        fullWidth
        onChange={handleZipcodeSelectedAutocomplete}
        renderInput={(params) => <TextField {...params} label="Zipcode" />}
        value={filter.zipcode ?? null}
      />

      <RegionSelector
        name="region"
        placeholder="Alle Regionen"
        label="Region"
        regions={regions}
        value={filter.region}
        onChange={handleRegionSelected}
      />

      <LocationCategorySelector label="Kategorien" categories={categories} />

      <Grid container spacing={1} sx={{ mt: 1 }}>
        <Grid
          item
          xs={12}
          lg="auto"
          sx={{
            display: { xs: "none", md: "block" },
          }}
        >
          <Button
            sx={{
              width: "100%",
              [theme.breakpoints.up("lg")]: {
                width: "auto",
              },
            }}
            startIcon={
              <SvgIcon sx={iconStyles}>
                <CloseIcon />
              </SvgIcon>
            }
            onClick={handleToggle}
            variant="outlined"
            color="primary"
          >
            Schließen
          </Button>
        </Grid>
        <Grid item xs={12} lg="auto">
          <Button
            sx={{
              width: "100%",
              [theme.breakpoints.up("lg")]: {
                width: "auto",
              },
            }}
            startIcon={
              <SvgIcon sx={iconStyles}>
                <ResetIcon />
              </SvgIcon>
            }
            variant="outlined"
            color="secondary"
            onClick={handleResetFilter}
          >
            Filter zurücksetzen
          </Button>
        </Grid>
      </Grid>

      <Box sx={{ display: "none" }}>
        {regions.map((region) => {
          return <div key={region.id}>{region.name}</div>;
        })}
      </Box>
    </>
  );
}

const iconStyles = {
  fontSize: "1rem",
  "& path": {
    fill: "currentcolor",
  },
};
